/**
 * Chart.js plugin that draws a rounded vertical bar behind each point
 * spanning the min..max of that bucket (Apple-Health style).
 *
 * How to use:
 *  - Attach per-point min/max on your dataset as `_minMax: [{min, max}, ...]`
 *  - Register this plugin with ChartJS.register(MinMaxBarsPlugin)
 *  - Optionally configure via options.plugins.minMaxBars: { lineWidth, color }
 */

export const MinMaxBarsPlugin = {
  id: "minMaxBars",
  /** @param {object} chart Chart.js chart instance passed by the plugin hook. */
  afterDatasetsDraw(chart, _args, pluginOptions) {
    const ds = chart.data.datasets?.[0];
    if (!ds || !Array.isArray(ds.data) || !Array.isArray(ds._minMax)) return;

    const meta = chart.getDatasetMeta(0);
    const { ctx, chartArea, scales } = chart;
    const yScale = scales.y;

    ctx.save();
    ctx.lineWidth = pluginOptions?.lineWidth ?? 8;
    ctx.strokeStyle = pluginOptions?.color ?? "rgba(0,0,0,0.25)";
    ctx.lineJoin = "round";
    ctx.lineCap = "round";

    ds.data.forEach((_, i) => {
      const elem = meta.data[i];
      const mm = ds._minMax[i];
      if (!elem || !mm || !Number.isFinite(mm.min) || !Number.isFinite(mm.max))
        return;

      const x = elem.x;
      const yMin = yScale.getPixelForValue(mm.min);
      const yMax = yScale.getPixelForValue(mm.max);
      const y1 = Math.max(Math.min(yMin, chartArea.bottom), chartArea.top);
      const y2 = Math.max(Math.min(yMax, chartArea.bottom), chartArea.top);

      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    });

    ctx.restore();
  },
};
